import axios from "axios";
import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { ReactComponent as ChevronLeft } from "../assets/feathericons/chevron-left.svg";

const FormAnswer = () => {
  const location = useLocation();
  const history = useHistory();
  const [data, setData] = useState(location.state);
  const numberQuestion = data.questions.length;

  //  manage turn of questions :
  const [starting, setStarting] = useState(false);
  const [nextQuestion, setNextQuestion] = useState(0);
  const [actualQuestion, setActualQuestion] = useState(
    data.questions[nextQuestion]
  );

  //   state for answers type and push in answer [] :
  const [radioValue, setRadioValue] = useState("1");
  const radios = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5", value: "5" },
  ];
  const [textarea, setTextarea] = useState("");
  const [answer, setAnswer] = useState([]);

  // going to the next question
  const handleNextQuestion = (e) => {
    if (nextQuestion === numberQuestion) {
      console.log("fin - soumettre les réponses");
    } else {
      const newQuestion = nextQuestion + 1;
      setNextQuestion(newQuestion);
      setActualQuestion(data.questions[newQuestion]);

      // i push all the answers of my user in an array
      if (actualQuestion.type === "text") {
        const qstText = [...answer];
        qstText.push(textarea);
        setAnswer(qstText);
        setTextarea("");
      } else {
        const qstNote = [...answer];
        qstNote.push(radioValue);
        setAnswer(qstNote);
        setRadioValue("1");
      }
    }
  };

  //  save all responses in bdd an go back to home
  const saveData = async () => {
    try {
      const response = await axios.post(
        `https://tellmemore-mahe.herokuapp.com/form/${data._id}/edit`,
        {
          answers: [answer],
        }
      );
      setData(response.data);
      history.push("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <div className="margin50">
        <div className="form form-edit my-forms top-screen ">
          <div className="top-screen">
            <div
              className="my-forms"
              onClick={() => {
                history.push("/");
              }}
            >
              <ChevronLeft />
              <p>Mes formulaires</p>
            </div>
          </div>
        </div>

        <div className="container-answer-question">
          {/* if starting is false, click on start and let's go ! */}
          {!starting ? (
            <div className="start">
              <p>SONDAGE</p>
              <h1>{data.name}</h1>
              <p className="nbQst">{numberQuestion} questions</p>
              <div className="starting" onClick={() => setStarting(true)}>
                <a className="btn-answer" href="#">
                  Commencer
                </a>
              </div>
            </div>
          ) : (
            <div className="answers">
              {/* if total is not in the final so we can click on next button : */}
              {nextQuestion !== numberQuestion ? (
                <>
                  <div>QUESTION {nextQuestion + 1}</div>
                  <div className="name-question">{actualQuestion.name}</div>
                  {/* search the type of question for answer with textarea or note */}
                  {actualQuestion.type === "text" ? (
                    <textarea
                      placeholder="Répondez ici..."
                      className="textarea-answer"
                      value={textarea}
                      onChange={(event) => setTextarea(event.target.value)}
                    ></textarea>
                  ) : (
                    <div className="note-answer">
                      <ButtonGroup toggle>
                        {/* radio buttons */}
                        {radios.map((radio, idx) => (
                          <ToggleButton
                            key={idx}
                            type="radio"
                            variant="secondary"
                            name="radio"
                            value={radio.value}
                            checked={radioValue === radio.value}
                            onChange={(e) =>
                              setRadioValue(e.currentTarget.value)
                            }
                          >
                            {radio.name}
                          </ToggleButton>
                        ))}
                      </ButtonGroup>
                    </div>
                  )}
                  <div
                    className="starting"
                    onClick={(e) => handleNextQuestion(e)}
                  >
                    <a className="btn-answer" href="#">
                      Suivant
                    </a>
                  </div>
                </>
              ) : (
                <>
                  {/* onClick in the final of form, save the data on the database */}
                  <div className="name-question" style={{ marginTop: 140 }}>
                    Merci d'avoir répondu à ce formulaire !
                  </div>
                  <div
                    className="starting"
                    onClick={saveData}
                    style={{ marginTop: 40 }}
                  >
                    <a className="btn-answer" href="#">
                      Accéder à mes formulaires
                    </a>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FormAnswer;
